class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    // ------------------------------
    // FV ニュース
    // ------------------------------
    $(".js-news-trigger").click(function() {
      $('.js-news .is-active').fadeOut(200);
      setTimeout(() => {
        console.log($('.js-news .is-active').next());
        if($('.js-news .is-active').next().length) {
          $('.js-news .is-active').removeClass('is-active').next().addClass('is-active').fadeIn(200);
        } else {
          $('.js-news .is-active').removeClass('is-active');
          $('.js-news > div').eq(0).addClass('is-active').fadeIn(200)
        }
      }, 200);
    })

    // ------------------------------
    // 施設写真スライダー
    // ------------------------------
    const fv_swiper = new Swiper(".fv-swiper", {
      loop: true,
      speed: 10000,
      allowTouchMove: false,
      autoplay: {
        delay: 0, // 途切れなくループ
      },
      spaceBetween: 20,
      slidesPerView: 1.4,
      breakpoints: {
        // 768px以上の場合
        1800: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
        960: {
          slidesPerView: 2.7,
          spaceBetween: 20,
        }
      },
    });

    // ------------------------------
    // バナースライダー
    // ------------------------------
    const bnr_swiper = new Swiper(".bnr-swiper", {
      loop: true,
      speed: 6000,
      allowTouchMove: false,
      autoplay: {
        delay: 0, // 途切れなくループ
      },
      spaceBetween: 20,
      slidesPerView: 3.1,
      breakpoints: {
        // 768px以上の場合
        1800: {
          slidesPerView: 10,
          spaceBetween: 30,
        },
        960: {
          slidesPerView: 7,
          spaceBetween: 20,
        }
      },
    });
  }
}